/* WooCommerce Archive – Load More / Infinite */
export function mount() {
  const $ = window.jQuery;
  if (!$) return;

  // Guard: niet dubbel initialiseren
  if (document.documentElement.dataset.wkArchiveLoadMore === '1') return;
  document.documentElement.dataset.wkArchiveLoadMore = '1';

  const root = $('[data-archive-load-more-root]');
  const type = (window.WcArchive && WcArchive.pagination) || 'numbers';
  if (!root.length || (type !== 'load_more' && type !== 'infinite')) return;

  const btn = root.find('[data-archive-load-more]');
  const spinner = root.find('[data-archive-spinner]');
  const grid = $('[data-archive-grid]').length ? $('[data-archive-grid]') : $('.grid.gap-6'); // fallback
  let page = 2;

  const fetchPage = () => {
    btn.prop('disabled', true).attr('aria-busy', 'true');
    spinner.removeClass('hidden');

    $.post(WcArchive.ajax, {
      action: 'wc_archive_load',
      nonce:  WcArchive.nonce,
      page,
      queryVars: WcArchive.queryVars || {},
    })
    .done(res => {
      if (res && res.success && res.data && res.data.html) {
        grid.append(res.data.html);
        page++;
        if (page > res.data.max_pages) {
          btn.remove();
          $(window).off('scroll.archiveInfinite');
        } else {
          btn.prop('disabled', false).removeAttr('aria-busy');
        }
      } else {
        btn.remove();
      }
    })
    .always(() => {
      spinner.addClass('hidden');
    });
  };

  if (type === 'load_more') {
    btn.prop('hidden', false).on('click', fetchPage);
  }

  if (type === 'infinite') {
    $(window).on('scroll.archiveInfinite', function () {
      const nearBottom = $(window).scrollTop() + $(window).height() > $(document).height() - 600;
      if (nearBottom && !btn.is('[aria-busy="true"]')) fetchPage();
    });
  }
}
